import { AxiosError } from 'axios';
import {  useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../models/https';
import {
    IScheduleDeliveryResponse,
    ScheduleDeliveryDataType,
} from '../../models/scheduleDelivery/scheduleDelivery';
import useHttps from '../useHttps';
import useTrackPackages from '../trackPackage/useSetTrackPackage';
import { useParams } from 'react-router-dom';

const useScheduleDelivery = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const { trackingId } = useParams();

    const { trackPackages } = useTrackPackages();

    const onScheduleDeliveryError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while scheduling delivery',
        );
    };

    const onScheduleDeliverySuccess = ({
        data,
        message,
    }: SuccessHttpResponse<IScheduleDeliveryResponse>) => {
        if (trackingId) {
            trackPackages(trackingId);
        }
        toast.success(message);
    };

    const scheduleDelivery = (data: ScheduleDeliveryDataType) => {
        const url: HttpConfig = {
            url: 'dispatch-service/api/v1/open/consignees/schedule/delivery',
            method: 'post',
            data,
        };

        request(url, onScheduleDeliverySuccess, setLoading, onScheduleDeliveryError);
    };

    return { scheduleDelivery, loading };
};

export default useScheduleDelivery;
